/**
 * @fileoverview AR-924 — Brand-colored "uploaded by teacher" mark on the corner of a done deliverable cell
 * (and of the matching legend entry).
 */

import { ThemeIcon } from '@mantine/core'
import { IconArrowUp } from '@tabler/icons-react'

/** Figma: 16px disc with a 2px white ring, overlapping the cell corner by 4px. */
const MARK_SIZE = 16
const MARK_ICON_SIZE = 10
const MARK_ICON_STROKE = 3
const MARK_OFFSET = -4
const MARK_RING = 2

export function TeacherUploadMark() {
  return (
    <ThemeIcon
      size={MARK_SIZE}
      radius="xl"
      variant="filled"
      aria-hidden
      data-testid="teacher-upload-mark"
      sx={theme => ({
        position: 'absolute',
        right: MARK_OFFSET,
        bottom: MARK_OFFSET,
        border: `${MARK_RING}px solid ${theme.white}`,
        pointerEvents: 'none',
      })}
    >
      <IconArrowUp size={MARK_ICON_SIZE} stroke={MARK_ICON_STROKE} />
    </ThemeIcon>
  )
}
